import type { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ExternalLink, LottiePlayer } from '@repo/design-system-kit';
import styles from './success.module.css';

export function Success(): ReactNode {
  const { locale } = useIntl();

  const linkByLocale: Record<string, string> = {
    fr: 'https://qonto.com/fr',
    de: 'https://qonto.com/de',
    it: 'https://qonto.com/it',
    es: 'https://qonto.com/es',
    en: 'https://qonto.com/en',
  };

  const link = linkByLocale[locale];

  return (
    <div className={styles.container} data-test-sdd-payment-link-success>
      <LottiePlayer
        autoplay
        className={`${styles.lottie} mb-32`}
        loop={false}
        path="/lotties/qonto-logo.json"
      />
      <h1 className="title-1 mb-8">
        <FormattedMessage id="sdd-collections.payment-link-page.success.title" />
      </h1>
      <p className="body-1 mb-32">
        <FormattedMessage id="sdd-collections.payment-link-page.success.description" />
      </p>
      <ExternalLink display="button" href={link}>
        <FormattedMessage id="sdd-collections.payment-link-page.success.text" />
      </ExternalLink>
    </div>
  );
}
